import React from "react";

const Logo = () => {
  return (
    <svg id="svg-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216.26 99.42">
      <text
        transform="translate(0 35.16)"
        fontSize="40.99"
        fill="currentColor"
        fontFamily="Arial-Black, Arial"
        fontWeight="800"
      >
        NO MORE
      </text>
      <text
        transform="translate(202.61 86.85)"
        fontSize="40.99"
        fill="currentColor"
        fontFamily="Arial-Black, Arial"
        fontWeight="800"
      >
        .
      </text>
      <rect
        x="2.38"
        y="49.93"
        width="191.21"
        height="36.64"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Logo;
